namespace h5_vm {
   import IPromise = angular.IPromise;
   import VmProvisioningPageModel = h5_vm.VmProvisioningPageModel;

   interface PolicySpec {
      type: string;
      policy: string;
   }

   interface StorageSpec {
      datastore: string;
      storagePolicy: PolicySpec | null;
   }

   class CloneVmReviewPageModelFactory {
      public static $inject = [
         "mutationService",
         "defaultUriSchemeUtil",
         "wizardPageService",
         "i18nService",
          "featureFlagsService"
      ];

      constructor(mutationService: any,
            defaultUriSchemeUtil: any,
            wizardPageService: any,
            i18nService: any,
            featureFlagsService: any) {
         return (wizardViewData: any, wizardScope: any) => {
            return new CloneVmReviewPageModel(
                  mutationService,
                  defaultUriSchemeUtil,
                  wizardPageService,
                  i18nService,
                  featureFlagsService,
                  wizardViewData,
                  wizardScope);
         };
      }
   }

   export class CloneVmReviewPageModel implements VmProvisioningPageModel<any> {

      static $inject: string[] = [
         "mutationService",
         "defaultUriSchemeUtil",
         "wizardPageService",
         "i18nService",
         "featureFlagsService"
      ];

      private readonly ADD_VM_TO_LIB_SPEC: string = "com.vmware.vsphere.client.provisioning.spec.AddToLibrarySpec";
      private readonly CREATE_VMTX_SPEC: string = "com.vmware.vsphere.client.h5.vmtx.libraryItem.specs.CreateVmtxLibraryItemSpec";
      private readonly DEFAULT_STORAGE_ID: string = "defaultId";
      private readonly USE_SPECIFIED_STORAGE_POLICY: string = "USE_SPECIFIED_POLICY";

      // wizardViewData is already part of the passed wizardScope, so consider removing
      // it as a parameter!
      constructor(private mutationService: any,
            private defaultUriSchemeUtil: any,
            private wizardPageService: any,
            private i18nService: any,
            private featureFlagsService: any,
            public wizardViewData: any,
            public wizardScope: any) {
      }

      public resetForm(): void {
      };

      public validatePage(): any {
         return {};
      };

      public submitPage(validationResult: any): IPromise<any> {
         if(this.wizardScope.cloneVmBasicInformationPageModel.basicInformation.templateType === TemplateType.VM_TEMPLATE){
             return this.cloneVmtxTemplate();
         }else{
            return this.cloneOvfTemplate();
         }

      };

       private cloneOvfTemplate(): IPromise<any> {
           let vmId: string = this.wizardViewData.getSourceObjectId();
           let ovfSpec: any = this.getOvfSpec();
           this.wizardPageService.showLoadingIndicator(this.wizardScope.config);

           return this.mutationService.apply(vmId, this.ADD_VM_TO_LIB_SPEC, ovfSpec)
               .then(() => {
                   this.wizardPageService.hideLoadingIndicator(this.wizardScope.config);
                   return true;
               });
       }


       private getOvfSpec(): any {
           let basicInformation: any = this.wizardScope.cloneVmBasicInformationPageModel.basicInformation;

           let libraryId: string;
           let libraryItemId: string;
           if (basicInformation.cloneOvfType === "new"){
              libraryItemId = "";
              libraryId = this.wizardScope.cloneVmLocationPageModel.contentLibrary.id;
           }else{
               libraryItemId = this.wizardScope.cloneVmLibraryItemPageModel.contentLibraryItem.id;
               libraryId = this.wizardScope.cloneVmLibraryItemPageModel.contentLibraryItem.libraryId;
           }
           let exportFlags: Array<string> = this.wizardScope.datastorePageModel.form.isAdvancedStorageMode;
           let spec:any = {
               contentLibrary: libraryId,
               name: basicInformation.name,
               description: basicInformation.notes,
               libraryItem: libraryItemId,
               exportFlags: this.buildOvfExportFlagsList(basicInformation.ovfExportFlags)
           };
           return spec;
       }

       private buildOvfExportFlagsList(ovfExportFlags: any): string[] {
           const exportFlags: string[] = [];
           if (Array.isArray(ovfExportFlags)) {
               ovfExportFlags.forEach((ovfExportFlag) => {
                   if (ovfExportFlag.selected) {
                       exportFlags.push(ovfExportFlag.option);
                   }
               });
           }
           return exportFlags;
       }

      private cloneVmtxTemplate(): IPromise<any> {
         let vmId: string = this.wizardViewData.getSourceObjectId();
         let vmtxSpec: any = this.getVmtxSpec();
         this.wizardPageService.showLoadingIndicator(this.wizardScope.config);

         return this.mutationService.apply(vmId, this.CREATE_VMTX_SPEC, vmtxSpec)
               .then(() => {
                  this.wizardPageService.hideLoadingIndicator(this.wizardScope.config);
                  return true;
               });
      }

      private getVmtxSpec(): any {
         let basicInformation: any = this.wizardScope.cloneVmBasicInformationPageModel.basicInformation;
         let libraryId: string = this.wizardScope.cloneVmLocationPageModel.contentLibrary.id;
         let isAdvancedStorageMode: boolean = this.wizardScope.datastorePageModel.form.isAdvancedStorageMode;
         if(!this.wizardScope.cloneVmBasicInformationPageModel.isVMTXPhase2Enabled){

            return _.extend({
               contentLibrary: libraryId,
               name: basicInformation.name,
               description: basicInformation.notes
            }, isAdvancedStorageMode ? this.getAdvancedStorageSpec() : this.getSimpleStorageSpec());
         }
         let spec:any = _.extend({
            contentLibrary: libraryId,
            name: basicInformation.name,
            description: basicInformation.notes,
            folder: this.wizardScope.vmParams.getTargetInformation().folderUid
         }, isAdvancedStorageMode ? this.getAdvancedStorageSpec() : this.getSimpleStorageSpec());

         let computeResourceId: string =
             this.wizardScope.vmParams.getComputeResourceId();
         let type: string = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(computeResourceId).type;
         switch (type) {
            case "ClusterComputeResource":
               return _.extend(spec, {
                  cluster: computeResourceId
               });
            case "HostSystem":
               return _.extend(spec, {
               host: computeResourceId
            });
            case "ResourcePool":
               return _.extend(spec, {
                  resourcePool: computeResourceId
               });
            case "VirtualApp":
               return _.extend(spec, {
                  resourcePool: computeResourceId
               });
            default:
               throw new Error("Unknown compute resouce id: " + computeResourceId);
         }

      }

      public getComputeResourceInfo(): Object {
         let computeResourceId: string =
             this.wizardScope.vmParams.getComputeResourceId();
         let computeResourceName: string =
             this.wizardScope.vmParams.getComputeResourceName();
         let label: string = this.labelForType(computeResourceId);

         return {
            name: computeResourceName,
            label: label
         };
      }

      public labelForType(urn: string): string {
         let type: string = this.defaultUriSchemeUtil.getPartsFromVsphereObjectId(urn).type;

         switch (type) {
            case "ClusterComputeResource":
               return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Cluster");
            case "HostSystem":
               return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.Host");
            case "ResourcePool":
               return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
            case "VirtualApp":
               return this.i18nService.getString("VmUi", "ProvisioningWizardSummaryPage.RP");
            default:
               throw new Error("Unknown compute resouce id: " + urn);
         }
      }

      private getAdvancedStorageSpec(): any {
         let storageConfig: any = this.wizardScope.datastorePageModel.form.storageSelectorState.vmStorageConfigInAdvancedMode[0];
         let vmHomeSpec: any = this.getStorageSpecFromVmStorageComponent(storageConfig.vmHome);

         let diskStorageOverrideSpec: any = {};
         for (let index = 0; index < storageConfig.vmDisks.length; index++) {
            let vmDisk: any = storageConfig.vmDisks[index];
            diskStorageOverrideSpec[vmDisk.key] = this.getStorageSpecFromVmStorageComponent(vmDisk);
         }

         return {
            vmHomeStorage: vmHomeSpec,
            diskStorageOverrides: diskStorageOverrideSpec
         };
      }

      private fixStorageSpec(spec: StorageSpec): void {
         if (!spec || !spec.storagePolicy) {
            return;
         }
         const policy: string | null = spec.storagePolicy.policy;
         if (!policy || policy === '') {
            spec.storagePolicy = null;
         }
         return;
      }

      private getSimpleStorageSpec(): any {
         let datastorePageModelForm: any = this.wizardScope.datastorePageModel.form;
         let datastoreRef: any = datastorePageModelForm.selectedStorage.storageRef;
         let datastoreId: string = this.defaultUriSchemeUtil.createVmomiUri(
               datastoreRef.type,
               datastoreRef.value,
               datastoreRef.serverGuid
         );
         let selectedProfileForDisksId: string = datastorePageModelForm.storageProfilesData._currentVmProfileAssignment.vmHomeProfile.id;
         let hasDefaultStoragePolicy: boolean = selectedProfileForDisksId === this.DEFAULT_STORAGE_ID;

         let storageSpec: StorageSpec = {
            datastore: datastoreId,
            storagePolicy: hasDefaultStoragePolicy ? null : {
               type: this.USE_SPECIFIED_STORAGE_POLICY,
               policy: selectedProfileForDisksId
            }
         };
         this.fixStorageSpec(storageSpec);

         return {
            vmHomeStorage: storageSpec,
            diskStorage: storageSpec
         };
      }

      private getStorageSpecFromVmStorageComponent(storageComponent: any): StorageSpec {
         let datastoreRef: any = storageComponent.storageObj.storageRef;
         let datastoreId: string = this.defaultUriSchemeUtil.createVmomiUri(
               datastoreRef.type,
               datastoreRef.value,
               datastoreRef.serverGuid
         );
         let selectedProfileId: string = storageComponent.storageProfile ?
               storageComponent.storageProfile.id : '';
         let hasDefaultStoragePolicy: boolean = selectedProfileId === this.DEFAULT_STORAGE_ID;

         let retVal:StorageSpec =  {
            datastore: datastoreId,
            storagePolicy: hasDefaultStoragePolicy ? null : {
               type: this.USE_SPECIFIED_STORAGE_POLICY,
               policy: selectedProfileId
            }
         };
         this.fixStorageSpec(retVal);
         return retVal;
      }
   }

   angular.module("com.vmware.vsphere.client.vm")
         .service("cloneVmReviewPageModel",
               CloneVmReviewPageModelFactory);
}
